import { usePage } from '~/templates/pages';
import { BasePage } from '~/lib/data-contract';
import styles from './n80-trustpilot.module.css';
import { RawHtml } from '~/shared/components';
import { useEffect, useRef, useState } from 'react';
import { useInView } from '~/shared/hooks/useInView/useInView';

type Props = {
    markup?: string;
};

export const N80Trustpilot = ({ markup }: Props) => {
    const { type = '' } = usePage<BasePage>();
    const [hasIntersected, setHasIntersected] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    const isInView = useInView(ref, {
        rootMargin: '250px 0px 250px 0px',
        once: true,
    });

    useEffect(() => {
        if (isInView) {
            setHasIntersected(true);
        }
    }, [isInView]);

    if (type === 'p100CheckoutPage') {
        return null;
    }

    if (!markup) {
        return null;
    }

    return (
        <div className={styles.root} ref={ref}>
            {hasIntersected ? <RawHtml html={markup} /> : null}
        </div>
    );
};
